export default {
  s3: {
    REGION: 'ap-southeast-2',
    BUCKET: 'cloud9-431503666859-sam-deployments-ap-southeast-2'
  },
  apiGateway: {
    REGION: 'ap-southeast-2',
    URL: 'https://api.parvoalert.com'
  },
  cognito: {
    REGION: 'ap-southeast-2',
    USER_POOL_ID: 'ap-southeast-2_KsIdki5lk',
    APP_CLIENT_ID: 'i89421rumku7d9fn4mbbapli0',
    IDENTITY_POOL_ID: 'ap-southeast-2:ade4983c-3eb3-4e3f-9ece-050ce90f8053'
  },
  algolia: {
    CASE_INDEX: 'prod-CasesIndex',
    APP_ID: '5MDGY8JJ87',
    API_KEY: 'a79ba10fe82339e0f4433eb6eeab28df'
  }
}
